import api from '../services/api';
import alertService from './alert';

export async function downloadMetaAdsReportPdf({ adAccountId, days } = {}) {
  try {
    const response = await api.get('/marketing/meta-ads/report/pdf', {
      responseType: 'blob',
      params: { adAccountId, days },
    });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `meta-ads-report-${days || 30}d.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (err) {
    let message = 'Could not generate the report';
    if (err.response?.data instanceof Blob) {
      try {
        message = JSON.parse(await err.response.data.text())?.message || message;
      } catch {
        // keep default message
      }
    }
    alertService.error(message);
  }
}
